import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAks = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 42,
	viewBox: "0 0 43 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 42,
			height: 42,
			transform: "translate(0.654297)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.2673 5.32739L9.63037 6.37164V14.0615L15.2673 15.2629L20.9244 12.997V7.25874L15.2673 5.32739Z",
			fill: "url(#paint0_linear_112721_614)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.63037 6.37168V14.0616L15.3256 15.263V5.40601L9.63037 6.37168ZM12.0357 13.4685L10.4389 13.1542V7.2385L12.0357 6.98505V13.4685ZM14.5196 13.9247L12.6845 13.6256V6.86592L14.5196 6.5491V13.9247Z",
			fill: "#341A6E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.4689 5.42624L21.832 6.47049V14.1579L27.4689 15.3618L33.1084 13.0756V7.35505L27.4689 5.42624Z",
			fill: "url(#paint1_linear_112721_614)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.832 6.47043V14.1578L27.4892 15.3617V5.50476L21.832 6.47043ZM24.2171 13.5672L22.6203 13.253V7.33726L24.2171 7.0838V13.5672ZM26.701 14.0209L24.871 13.7244V6.96468L26.7035 6.62758L26.701 14.0209Z",
			fill: "#341A6E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.49139 15.932L3.85449 16.9788V24.6662L9.49139 25.8675L15.1486 23.6016V17.8659L9.49139 15.932Z",
			fill: "url(#paint2_linear_112721_614)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.83398 16.9788V24.6078L9.53171 25.8092V15.9523L3.83398 16.9788ZM6.21902 24.0933L4.62224 23.7588V17.8481L6.21902 17.5719V24.0933ZM8.72318 24.6078L6.89069 24.3113V17.4705L8.72318 17.1562V24.6078Z",
			fill: "#341A6E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.655 15.8535L16.0181 16.9003V24.5877L21.655 25.8093L27.2919 23.5231V17.7874L21.655 15.8535Z",
			fill: "url(#paint3_linear_112721_614)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0181 16.9002V24.6053L21.6955 25.8092V15.9523L16.0181 16.9002ZM18.4006 24.0148L16.8038 23.6802V17.767L18.4006 17.4882V24.0148ZM20.8845 24.4482L19.052 24.1542V17.3919L20.887 17.0776L20.8845 24.4482Z",
			fill: "#341A6E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.8181 15.9523L28.1787 16.9965V24.6864L33.8181 25.8878L39.4753 23.6219V17.8836L33.8181 15.9523Z",
			fill: "url(#paint4_linear_112721_614)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.1787 16.9965V24.6078L33.8764 25.8092V15.9523L28.1787 16.9965ZM30.5866 24.1136L28.9898 23.779V17.8659L30.5866 17.5871V24.1136ZM33.0704 24.547L31.2354 24.253V17.4908L33.0679 17.1739V24.5495L33.0704 24.547Z",
			fill: "#341A6E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1306 26.6559L9.49121 27.6824V35.3698L15.1306 36.5914L20.7878 34.3052V28.5898L15.1306 26.6559Z",
			fill: "url(#paint5_linear_112721_614)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.49121 27.6823V35.3697L15.1889 36.5939V26.5773L9.49121 27.6823ZM11.8991 34.7994L10.3023 34.4649V28.5492L11.8991 28.2729V34.7994ZM14.3829 35.2531L12.5479 34.9566V28.1766L14.3804 27.8598V35.2531H14.3829Z",
			fill: "#341A6E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.3122 26.7369L21.6753 27.7812V35.4685L27.3122 36.6725L32.9694 34.404V28.6708L27.3122 26.7395V26.7369Z",
			fill: "url(#paint6_linear_112721_614)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.6753 27.7812V35.4686L27.373 36.6725V26.813L21.6753 27.7812ZM24.0806 34.8983L22.4838 34.5612V28.648L24.0806 28.3718V34.8983ZM26.5645 35.3292L24.7295 35.0351V28.2729L26.5645 27.9586V35.3317V35.3292Z",
			fill: "#341A6E"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_112721_614",
				x1: 9.63037,
				y1: 10.2952,
				x2: 20.9244,
				y2: 10.2952,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#B77AF4" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#773ADC"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_112721_614",
				x1: 21.832,
				y1: 10.394,
				x2: 33.1084,
				y2: 10.394,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#B77AF4" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#773ADC"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_112721_614",
				x1: 3.85449,
				y1: 20.8998,
				x2: 15.1308,
				y2: 20.8998,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#B77AF4" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#773ADC"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_112721_614",
				x1: 16.0181,
				y1: 20.8213,
				x2: 27.2919,
				y2: 20.8213,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#B77AF4" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#773ADC"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_112721_614",
				x1: 28.1787,
				y1: 20.92,
				x2: 39.4753,
				y2: 20.92,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#B77AF4" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#773ADC"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_112721_614",
				x1: 9.49121,
				y1: 31.6262,
				x2: 20.7878,
				y2: 31.6262,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#B77AF4" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#773ADC"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_112721_614",
				x1: 21.6753,
				y1: 31.7047,
				x2: 32.9694,
				y2: 31.7047,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#B77AF4" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#773ADC"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgAks);
export { ForwardRef as ReactComponent };
